<h1 mat-dialog-title>Edit Constraints</h1>

<div mat-dialog-content>
  <div *ngIf="loading" class="text-center py-5">
    <mat-spinner [diameter]="40" class="mx-auto"></mat-spinner>
    <p class="mt-3 text-muted">Loading portfolio data...</p>
  </div>

  <div *ngIf="error" class="text-center py-4">
    <mat-icon class="text-danger" style="font-size: 40px; width: 40px; height: 40px;">error</mat-icon>
    <p class="mt-2 text-danger">{{ error }}</p>
  </div>

  <div *ngIf="!loading && !error">
    <app-constraint-setter
      [portfolio]="portfolio"
      [constraints]="constraints"
      [sectors]="sectors"
      [countries]="countries"
      [assets]="assets"
      (optimize)="onOptimize()"
    ></app-constraint-setter>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-stroked-button (click)="onClose()">Close</button>
</div>
